<template>
    <div class="message-scroll-container">
        <div v-if="showMessage">
            <div class="message-text-box" v-if="messageText" @click="jumpPage">
                <p ref="runTextRef" class="message-text-style text-run-animate">{{ messageText }}</p>
            </div>

            <div class="close-btn" @click="closeMessage"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'messageScroll',
    data () {
        return {
            messageText: '',
            linkUrl: '',
            startDate: '',
            endDate: '',
            showMessage: true
        }
    },
    mounted () {
        // console.log('消息数据：', window.data_source_100003725)
        if (window.data_source_100003725) {
            const { noticeConfig = {} } = window.data_source_100003725
            if (JSON.stringify(noticeConfig) === '{}') return
            this.messageText = noticeConfig.content
            // this.messageText = 'aaaaaaaaaaaaa'
            this.linkUrl = noticeConfig.link
            this.startDate = noticeConfig.onlineDate
            this.endDate = noticeConfig.offlineDate
        } else {
            // 关闭弹窗
            this.closeMessage()
            return
        }

        const nowDate = new Date()
        // const nowDate = '2021/05/08 00:00:00'
        // const nowDate = '2021/02/28 00:00:00'
        // console.log('当前时间戳', this.dateToTimestamp(nowDate))
        // console.log('开始时间戳', this.dateToTimestamp(this.startDate))
        // console.log('结束时间戳', this.dateToTimestamp(this.endDate))
        if (this.dateToTimestamp(nowDate) < this.dateToTimestamp(this.startDate) || this.dateToTimestamp(nowDate) > this.dateToTimestamp(this.endDate)) {
            // 关闭弹窗
            this.closeMessage()
            return
        }
        
        this.$nextTick(() => {
            let duration = 10
            // let duration = this.messageText.length / 3 > 10 ? this.messageText.length / 3 : 10
            // console.log(duration, this.$refs.runTextRef.clientWidth, document.body.clientWidth)
            const runTextWidth = this.$refs.runTextRef.clientWidth 
            const windowWidth = document.body.clientWidth

            duration = runTextWidth / 30

            let scrollProportion = '100%'
            if (runTextWidth > windowWidth) scrollProportion = `${(windowWidth / runTextWidth) * 100}%`
            // console.log(scrollProportion)
            // 执行文字滚动动画
            this.scrollAnimation(duration, scrollProportion)
        })

    },
    methods: {
        scrollAnimation (duration, scrollProportion) {
            // const duration = 10
            const styles = document.createElement('style')
            styles.innerHTML = `
                .text-run-animate {
                    -webkit-animation: scrollLeft ${duration}s 0s linear infinite;
                    animation: scrollLeft ${duration}s 0s linear infinite;
                }

                @keyframes scrollLeft {
                    0% {
                        transform: translate3d(${scrollProportion}, 0, 0);
                    }
                    100% {
                        transform: translate3d(-100%, 0, 0);
                    }
                }
            `
            const head = document.getElementsByTagName('head')[0]
            head.appendChild(styles)
        },
        jumpPage () {
            if (this.linkUrl) window.location.href = this.linkUrl
        },
        closeMessage () {
            this.showMessage = false
            this.$emit('closeEvent')
        },
        // 日期转换时间戳
        dateToTimestamp (date) {
            if (!date) return
            const timestamp = new Date(date)
            return timestamp.getTime()
        }
    }
}
</script>

<style lang="scss" scoped>
.message-scroll-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.36rem;
    background-color: #3A23EB;
    padding: 0.08rem 0.16rem;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 1;

    .message-text-box {
        position: relative;
        width: 3.1rem;
        height: 0.2rem;
        color: #ffffff;
        font-size: 0.14rem;
        line-height: 0.2rem;
        text-align: left;
        overflow: hidden;

        .message-text-style {
            position: absolute;
            width: auto;
            min-width: 100%;
            white-space: nowrap;
            // animation: scrollLeft 8s linear infinite;
        }
    }

    .close-btn {
        position: absolute;
        top: 0;
        right: 0.1rem;
        width: 0.36rem;
        height: 0.36rem;
        background: url('https://img14.360buyimg.com/imagetools/jfs/t1/176055/34/1096/309/6062cf02E603848ff/08b49cd4210d2e8e.png') no-repeat;
        background-size: 100% 100%;
    }
}
</style>